import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import { getToken } from '@/utils/auth'
import userTypes from '@/store/types/user'
// import permTypes from '@/store/types/permission'
import store from '@/store/index'
import { constantRouterMap } from './routerMap'
import { Message } from 'element-ui'

Vue.use(Router)

NProgress.configure({ showSpinner: false })

const router = new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

const whiteList = ['/login', '/authredirect', '/watermanage', '/tourist', '/openScreen'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  // console.log(`before: from:${from.path}, to:${to.path}`)
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login' || to.path === '/watermanage') {
      NProgress.done()
      next()
    } else if (to.path === '/openScreen') {
      next()
    } else {
      let v = new Vue()
      if (whiteList.indexOf(to.path) !== -1 || to.name === 'Homepage' || to.name === 'home' || to.name === 'meiyu' || to.name === 'riskchart') {
        next()
      } else {
        v.checkRouter(to.name).then(res => {
          if (res) {
            v.ListSubMenu(to.query.id).then(data => { res = data })

            store.dispatch(userTypes.GET_USER_INFO).then(user => { // 拉取user_info
              if (to.query.id === null || res.length === 0) {
                next()
              } else {
                store.dispatch('setAllowPerm', { name: to.query.id, type: res[0].type })
                router.push({ name: res[0].type })
                next()
              }
            })
          } else {
            Message.error('权限不足')
          }
        })
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next({ path: '/login' })
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
